import { samsungExtension } from '@cbsinteractive/avia-js-samsung';
import { ITagAbstractClassArgument } from 'tag/ts/tag/interfaces/arguments/ITagAbstractClassArgument';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { AviaExtension } from 'tag/ts/tag/player/adapters/avia/extensions/AviaExtension';
import { IAviaExtension } from 'tag/ts/tag/player/adapters/avia/interfaces/IAviaExtension';

export class SamsungCapabilitiesExtension extends AviaExtension implements IAviaExtension {
	package = samsungExtension;
	namespaceKey = 'plugin_samsung';

	constructor( argument: ITagAbstractClassArgument ) {
		super( {
			...argument,
			name: 'SamsungCapabilitiesExtension'
		} );
	}

	shouldBeUsed() {
		if ( !super.shouldBeUsed() ) return false;

		const samsungAPIExists = this.utils.Type.isDefined( window?.webapis );
		const html5Embed = this?.params?.SYSTEM?.embedType === EmbedType.HTML5;

		if ( html5Embed && samsungAPIExists ) {
			this?.logger?.log( 'Samsung API detected:', window?.webapis );
		}

		return html5Embed && samsungAPIExists;
	}
}